import React from "react";
import styled from "styled-components";
import { LineChart } from "@mui/x-charts/LineChart";

const Wrap = styled.div`
    background-color: #FFFFFF; border: 1px solid #EFEFEF;
    border-radius: 12px; padding: 16px; margin-bottom: 24px;
    .h { color: #25368D; font-size: 16px; font-weight: 600; margin-bottom: 12px; }
    .empty { color: #838BB4; padding: 60px 0; text-align: center; }
`;

export default function TimeseriesChart({ data }) {
    const rows = data || [];
    if (!rows.length) {
        return <Wrap><div className="h">การใช้งานรายวัน</div><div className="empty">ไม่มีข้อมูล</div></Wrap>;
    }
    const xLabels = rows.map(r => r.bucket);
    const subs    = rows.map(r => r.submissions);
    const atts    = rows.map(r => r.attendances);
    return (
        <Wrap>
            <div className="h">การใช้งานรายวัน</div>
            <LineChart
                height={320}
                xAxis={[{ data: xLabels, scaleType: "point" }]}
                series={[
                    { data: subs, label: "Submissions", color: "#25368D" },
                    { data: atts, label: "Attendances", color: "#FBE250" },
                ]}
                margin={{ left: 60, right: 20, top: 30, bottom: 50 }}
            />
        </Wrap>
    );
}
